module.exports = __webpack_public_path__ + "static/media/profile-provider-logo.a0e7f05f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/profile-provider-logo.svg
// module id = 2028
// module chunks = 0